import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { AppUrlField } from './AppUrlField';

export const AppUrlFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'AppUrlField',
    component: AppUrlField,
  }),
);
